import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import UnrecognisedImportFilesReportCriteria from './UnrecognisedImportFilesReportCriteria';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';


@NeoReport("UnrecognisedImportFiles",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class UnrecognisedImportFilesReport extends Report<UnrecognisedImportFilesReportCriteria>{

    constructor() {
        super(UnrecognisedImportFilesReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
            <Neo.GridLayout lg={3} md={3}>
                <Neo.FormGroup appendText="fa-calendar" bind={this.criteria.meta.reportingDate} label={TextConstants.Labels.Date}/>
            </Neo.GridLayout>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}